import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'kt-alert',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent {

	constructor(
		public dialogRef: MatDialogRef<InfoComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: AlertData) {
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

}

export interface AlertData{
	title: string;
	mensaje: string;
}
